import React from 'react';
// import { Link } from "react-router-dom";


const social = [
  { id: 0, title: "Xing", url: "https://www.xing.com/profile/Christoph_Breitbach", img: "/img/icons/cbr_icon_xing.png"},
  { id: 1, title: "LinkedIn", url: "https://www.linkedin.com/in/christoph-breitbach-014971133/", img: "/img/icons/cbr_icon_linkedin.png"},
  // { id: 2, title: "Skype", url: "skype:chbreitbach", img: "/img/icons/cbr_icon_skype.png"},
  { id: 3, title: "Facebook", url: "https://www.facebook.com/christoph.breitbach", img: "/img/icons/cbr_icon_facebook.png"},
  { id: 4, title: "Instagram", url: "https://www.instagram.com/christophbreitbach/", img: "/img/icons/cbr_icon_instagram.png"},
  // { id: 5, title: "Twitter", url: "https://twitter.com/chbreitbach", img: "/img/icons/cbr_icon_twitter.png"},
];

const team = [
  { id: 5, name: 'Vesna Baranovic', loc: 'Düsseldorf', url: 'behance.net/Vesna1706'},
  { id: 10, name: 'Patrick Hahne', loc: 'Düsseldorf', url: 'herrhahne.myportfolio.com'},
  // { id: 2, name: 'Jan Lorenz', loc: 'Köln', url: 'lorenzundkonsorten.com'},
  // { id: 20, name: 'Chris Brenner', loc: 'Düsseldorf', url: 'chris-brenner.com'},
  { id: 30, name: 'Dirk Ollmann', loc: 'Hamburg', url: 'dirkollmann.myportfolio.com'},
  { id: 35, name: 'Sebastian Groebner', loc: 'Hamburg', url: 'sebastiangroebner.com'},
  { id: 40, name: 'Djik Ouchiian', loc: 'Hamburg', url: 'ouchiian.com'},
  { id: 50, name: 'Christian Schütze', loc: 'Hamburg', url: 'christianschuetze.de'},
  { id: 60, name: 'Birgit Hogrefe', loc: 'Hamburg', url: 'birgithogrefe.de'},
  { id: 65, name: 'Ronald Liedmeier', loc: 'Berlin', url: 'liedmeier.com'},
  // { id: 70, name: 'Alexander Gutt', loc: 'Hamburg', url: 'alexandergutt.com'}
  { id: 70, name: 'Frederick Kober', loc: 'Berlin', url: 'frederickkober.myportfolio.com'}
];



// const Topic = ({ match }) => (
//     <div>
//       <h3>{match.params.topicId}</h3>
//     </div>
// );


const Contact = ({ match }) => {

  const sociallinks = social.map((entry) =>
      <a
          href={entry.url}
          key={entry.id}
          className="cb-social-entry"
          target={"_blank"}
          style={ {backgroundImage: "url('" + process.env.PUBLIC_URL + entry.img + "')"} } > </a>
  );

  const teampartner = team.map((entry) => (
      <div className={"cb-teamentry"} key={entry.id}>
        <a href={'http://' + entry.url} target={"_blank"}>
           {entry.name}
        </a>
        <span> {entry.loc} | </span>
      </div>
      )
  );

  return(
      <div className={"cb-page-contact"}>

        <h2>Mich gibt’s auch zu zweit.</h2>

        <div className={"cb-fullwidth"}>
          <p>
            Ob im Team mit einem erstklassigen Art Director oder als Ein-Mann-Armee, für Pitches oder Tagesgeschäft,
            als Urlaubsvertretung oder sonstiger Ersatz für einen Texter oder Text-CD: Ich unterstütze Euch gern. An
            meinem Standort Düsseldorf und im Rest der Welt, remote oder vor Ort.
          </p>

          <p>
            Mobil: +49 (0) 163 31 32 336<br />
            E-Mail: <a href="mailto:mail@christophbreitbach.de">mail@christophbreitbach.de</a>
          </p>

          <p className={"cb-tp-title"}><b>Teampartner</b></p>
          <div className={"cb-teampartner"}>
            {teampartner}
            <div className={"cb-teamentry"}>
              <span>u.a.</span>
            </div>
          </div>

          <div className={"cb-sociallinks"}>
            {sociallinks}
          </div>

        </div>

      </div>
  );
};



export { Contact };


// WEBPACK FOOTER //
// ./src/includes/Contact.jsx